import { render, staticRenderFns } from "./choosevoice.vue?vue&type=template&id=49de6482&scoped=true"
import script from "./choosevoice.vue?vue&type=script&lang=js"
export * from "./choosevoice.vue?vue&type=script&lang=js"
import style0 from "./choosevoice.vue?vue&type=style&index=0&id=49de6482&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49de6482",
  null
  
)

export default component.exports